import { getBrandName, getCountry, getLanguage } from '../utils/helpers';
import { getData } from '../../globals/http';
import { ATG_PRODUCT_SOFTWARE_PATH, isV3 } from '@pes-ui/utils';
const getProductSoftwareUrl = (locale, productId) => {
  const countryCode = getCountry(locale);
  const languageCode = getLanguage(locale);
  const ATG_PRODUCT_SOFTWARE_URL = `${locale}${ATG_PRODUCT_SOFTWARE_PATH}/${productId}`;
  const SPRYKER_PRODUCT_SOFTWARE_URL = `/products/${productId}/software-list?brand=${getBrandName()}&country-code=${countryCode}&language-code=${languageCode}`;
  return isV3() ? SPRYKER_PRODUCT_SOFTWARE_URL : ATG_PRODUCT_SOFTWARE_URL;
};
export const getProductSoftware = async (locale, productId) => {
  const url = getProductSoftwareUrl(locale, productId);
  try {
    const documents = await getData(false, url);
    return documents.filter(({ link }) => Boolean(link));
  }
  catch (error) {
    return [];
  }
};
